import { render } from "./WidgetdoughnutChart.vue?vue&type=template&id=0868c38e"
import script from "./WidgetdoughnutChart.vue?vue&type=script&lang=js"
export * from "./WidgetdoughnutChart.vue?vue&type=script&lang=js"

import "./WidgetdoughnutChart.vue?vue&type=style&index=0&id=0868c38e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Charts/WidgetdoughnutChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0868c38e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0868c38e', __exports__)) {
    api.reload('0868c38e', __exports__)
  }
  
  module.hot.accept("./WidgetdoughnutChart.vue?vue&type=template&id=0868c38e", () => {
    api.rerender('0868c38e', render)
  })

}


export default __exports__